import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { locale as italian } from "../../../../i18n/it";
import { CommunicationsService } from "../../../../auth/service/communications.service";
import { RoleService } from "../../../../auth/service/role.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";
import { IDatatableConfig } from "../../../../auth/models/datatable";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { INotificationCategory } from "app/auth/models/notification";

@Component({
  selector: "app-categories-list",
  templateUrl: "./categories-list.component.html",
  styleUrls: ["./categories-list.component.scss"],
})
export class NotificationCategoriesListComponent implements OnInit {
  public config: IDatatableConfig;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public newCategoryCommunication: string = "";
  public currentCategory: INotificationCategory;
  public categories: INotificationCategory[];
  public addRoles: number[];
  public newDescription: string;
  public showModalErrors: boolean = false;

  constructor(
    public _communicationService: CommunicationsService,
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _roleService: RoleService,
    public _activatedRoute: ActivatedRoute,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.MENU.CATEGORIES_NOTIFICATIONS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.CATEGORIES_NOTIFICATIONS,
            isLink: false,
          },
        ],
      },
    };

    this.config = {
      exportable: false,
      searchable: false,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
    };
    await this.loadCategories();
    this._utilService.hideLoading();
  }

  async loadCategories() {
    this.categories = await this._communicationService.getListCategories();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  categoriesList() {
    let items: INotificationCategory[] = this.categories;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.categories.filter((item: INotificationCategory) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    return items;
  }

  async deleteCategory(currentCategory) {
    if (!this._authenticationService.hasCapability("delete_notification_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCategory.name;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        this._utilService.showLoading();
        await this._communicationService
          .deleteCategories(currentCategory.id)
          .then(async () => {
            this._utilService.hideLoading();
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadCategories();
            });
          })
          .catch(() => {
            this._utilService.hideLoading();
            this._utilService.showSWALError({ text: "ERROR_COMMUNICATION_CATEGORY_DELETE" });
          });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async addCategoryCommunication() {
    if (!this._authenticationService.hasCapability("create_notification_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.newCategoryCommunication) {
      this.newCategoryCommunication = this.newCategoryCommunication.trim();
    }

    if (!this.newCategoryCommunication || this.newCategoryCommunication.length < 4 || !this.addRoles || this.addRoles.length < 1) {
      this.showModalErrors = true;
      return false;
    }
    this._utilService.showLoading();
    await this._communicationService
      .createCategories({
        name: this.newCategoryCommunication,
        roles: this.addRoles,
        description: this.newDescription,
      })
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_COMMUNICATION_CATEGORY" });
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_COMMUNICATION_CATEGORY_UPLOAD" });
      });
  }

  async editCategoryCommunication() {
    if (!this._authenticationService.hasCapability("edit_notification_category")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentCategory.name) {
      this.currentCategory.name = this.currentCategory.name.trim();
    }

    if (!this.currentCategory.name || this.currentCategory.name.length < 4 || !this.addRoles || this.addRoles.length < 1) {
      this.showModalErrors = true;
      return false;
    }

    this._utilService.showLoading();
    await this._communicationService
      .updateCategories(this.currentCategory.id, {
        name: this.currentCategory.name,
        roles: this.addRoles,
        description: this.newDescription,
      })
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_COMMUNICATION_CATEGORY" });
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_COMMUNICATION_CATEGORY_EDIT" });
      });
  }

  public modalOpen(whichModal, category, action) {
    this.addRoles = [];
    this.newDescription = "";
    this.newCategoryCommunication = "";
    this.showModalErrors = false;

    this._modalService.open(whichModal, {
      size: "lg",
      centered: true,
    });
    this.currentCategory = JSON.parse(JSON.stringify(category));
    if (action === "edit") {
      this.addRoles = this.currentCategory.roles.map((role) => role.id);
      this.newDescription = this.currentCategory.description;
    }
  }
}
